import { Box, ThemeProvider } from '@mui/material';

import { ErrorPreviewLog } from 'src/pages/workflow-builder-preview/preview-logs/ErrorPreviewLog';
import { useGetThemeBasedOnMode } from 'src/pages/workflow-builder-preview/utils';
import { ErrorPreviewLogProps } from 'src/slices/workflow-preview/types';

/**
 * A recorded agent test error, rendered as the preview console renders it.
 *
 * ErrorPreviewLog is styled against the preview's own dark theme (dark greys,
 * a dark payload box, white text) rather than the page's. The test results
 * panel is dark too but runs under the app's light default, which turned the
 * payload box near-white under the panel's white text, so supply the theme.
 */
export const AgentTestRecordedError = ({
  previewLog,
}: {
  previewLog: ErrorPreviewLogProps;
}) => {
  const theme = useGetThemeBasedOnMode();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ color: theme.palette.colors.white, width: '100%' }}>
        <ErrorPreviewLog previewLog={previewLog} />
      </Box>
    </ThemeProvider>
  );
};
